import { render } from "./expertreportitemeditor.vue?vue&type=template&id=ff3fbfd4"
import script from "./expertreportitemeditor.vue?vue&type=script&lang=js"
export * from "./expertreportitemeditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__